import {emptyGuid} from "../../../../Utilities/commonUtilities";

export const braillerCatalogItemModel = ({
                                             braillerCatalogId = emptyGuid,
                                             title,
                                             cost,
                                             repairCost,
                                             model,
                                             description,
                                             purchaseDate,
                                             allowRepairs,
                                             totalQuantity,
                                             quantityCurrentlyAvailable,
                                             checkedOut,
                                             returned,
                                             isActive,
                                             systemType,
                                             dateCreatedUtc,
                                             dateModifiedUtc,
                                             repairs,
                                             inventoryItems
                                         }: Record<string, any> = {}) => ({
    braillerCatalogId,
    title,
    cost,
    repairCost,
    model,
    description,
    purchaseDate,
    allowRepairs,
    totalQuantity,
    quantityCurrentlyAvailable,
    checkedOut,
    returned,
    isActive,
    systemType,
    dateCreatedUtc,
    dateModifiedUtc,
    repairs: repairs || [],
    inventoryItems: inventoryItems || [],
});


export const emptyBraillerCatalogItemModel = braillerCatalogItemModel();


